export enum CouponCodeType {
    GS1_BarCode = 'GS1_BarCode',
    BarCode = 'BarCode',
    QR_Code = 'QR_Code',
  }